import { Box, LinearProgress } from '@mui/material';

export const Loader = () => {
  return (
    <Box
      sx={{
        '& .MuiLinearProgress-colorPrimary': {
          backgroundColor: 'rgba(100, 88, 241, 0.2)',
        },
        '& .MuiLinearProgress-barColorPrimary': {
          backgroundColor: '#6458F1',
        },
      }}
    >
      <LinearProgress />
    </Box>
  );
};
